import axios from 'axios'
import Nprogress from 'nprogress'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import Qs from 'qs'
import {
  resetAttribute,
  sortBy,
  sortArray,
  getSameKeyHalfValues,
  getSameAttribute
} from '@/utils/handleData.js'
import { getObjAttribute } from '@/utils/getPageInfo'
import {
  collectRowVideoUids,
  normalizeQiniuUid,
  toHttpsPlayUrl,
  qiniuVideoSourceType
} from '@/utils/fileUpload'
import { isBlockedBidLevelAction } from '@/utils/bidLevelActions.js'

// 请求响应超时时间
axios.defaults.timeout = 30000
// 设置请求拦截器
axios.interceptors.request.use((config) => {
  Nprogress.start()
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

// 设置响应拦截器
axios.interceptors.response.use(
  (config) => {
    Nprogress.done()
    return config
  },
  (error) => {
    Nprogress.done()
    const status = error && error.response && error.response.status
    if (status === 401) {
      Message({ message: '登录Token已过期，请重新登录', type: 'error' })
      window.sessionStorage.clear()
      window.localStorage.setItem('isChecked', '')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

const getRequest = (method, url, data, header, extra) => {
  const timeout = (extra && extra.timeout) || axios.defaults.timeout
  // method为请求方法，url为接口路径，data为传参
  if (method === 'POST' || method === 'PUT') {
    if (header) {
      return axios({
        url: url,
        data: Qs.stringify(data),
        method: method,
        headers: header,
        timeout
      })
    } else {
      return axios({
        url: url,
        data: JSON.stringify(data),
        method: method,
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        timeout
      })
    }
  } else {
    return axios({
      url: url,
      params: data,
      method: method,
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      timeout
    })
  }
}

const deleteRow = (rowData, uid, uidKey) => {
  rowData.forEach((item, index) => {
    if (item[uidKey] === uid) {
      rowData.splice(index, 1)
    } else if (item.children) {
      deleteRow(item.children)
    }
  })
}

const goBack = (commit, dispatch, params) => {
  if (params.getParentFun || params.getListFun) {
    dispatch(
      params.getParentFun
        ? params.getParentFun
        : params.getListFun
    )
  }
  commit('baseSet', {
    key: 'dialogFormVisible',
    value: false
  })
  commit('baseSet', {
    key: 'dialogTableVisible',
    value: false
  })
  commit('baseSet', {
    key: 'drawerTableVisible',
    value: false
  })
  commit('stepSet', {
    type: 'back'
  })
}

const gotoPath = (commit, path, state) => {
  const keep = JSON.parse(JSON.stringify((state && state.historyStep) || []))
  const from = JSON.parse(JSON.stringify((state && state.currentStep) || {}))
  if (from && from.step) {
    if (!from.path && state && state.activePath) from.path = state.activePath
    if (!from.tab && state && state.currentTab && state.currentTab.label) {
      from.tab = state.currentTab.label
    }
    keep.push(from)
  }
  commit('baseSet', {
    key: 'routeBreadcrumbKeep',
    value: keep
  })
  commit('baseSet', {
    key: 'dialogFormVisible',
    value: false
  })
  commit('baseSet', {
    key: 'dialogTableVisible',
    value: false
  })
  commit('baseSet', {
    key: 'drawerTableVisible',
    value: false
  })
  router.push(path)
}

const previewFile = async (state, commit, dispatch, params, page) => {
  if (!page || !page.previewParams) {
    if (!params.srcList || !params.srcList.length)
      return Message({ message: '没有可预览的图片或文件', type: 'error' })
    commit('baseSet', {
      key: 'srcList',
      value: params.srcList
    })
    commit('baseSet', {
      key: 'imageVisible',
      value: true
    })
  } else if (page.previewParams && page.previewParams.type === 'image') {
    if (!params.previewParams.value || params.previewParams.value.length)
      return Message({ message: '没有可预览的图片', type: 'error' })
    // 获取预览图片
    await commit('pictureSet', page.previewParams)
    params.srcList = getSameAttribute(
      state.pictures[page.previewParams.key],
      'url'
    ).values
    commit('baseSet', {
      key: 'srcList',
      value: params.srcList
    })
    commit('baseSet', {
      key: 'imageVisible',
      value: true
    })
  } else {
    commit('baseSet', {
      key: 'fileType',
      value: page.previewParams.type
    })
    // 获取预览文件
    let sources = {}
    if (page.previewParams.fileUrl) {
      sources.url = page.previewParams.fileUrl
      sources.type = page.previewParams.fileType
    } else if (page.previewParams.type === 'link') {
      sources.url = page.previewParams.uid
    } else if (page.previewParams.type === 'video') {
      sources.url = await dispatch('getQiniuFile', page.previewParams.uid)
      sources.type = qiniuVideoSourceType(
        sources.url,
        page.previewParams.fileType
      )
    } else {
      await commit('fileSet', page.previewParams)
      sources.url = state.files[page.previewParams.key].url
      sources.type = page.previewParams.fileType
    }
    sources.url = toHttpsPlayUrl(sources.url)
    if (!sources.url)
      return Message({ message: '获取预览文件失败', type: 'error' })
    if (page.previewParams.type === 'video') {
      sources.type = qiniuVideoSourceType(sources.url, sources.type)
    }
    commit('baseSet', {
      key: page.previewParams.type,
      value: sources
    })
    if (
      page.previewParams.type === 'video' ||
      page.previewParams.type === 'pdf'
    ) {
      commit('stepSet', {
        type: 'forward',
        forward: page
      })
    } else {
      window.open(sources.url)
    }
  }
}

const getDetailData = async (state, getters, dispatch, params, page) => {
  var detailData
  if (!page.checkType && !page.checkFun && getters[page.type]) {
    // 使用页面初始字段值
    if (page.type === 'cardForm') {
      detailData = {}
      getters.cardForm.cardFormNames.forEach((item) => {
        detailData[item] = getters.cardForm[item].formParams
          ? JSON.parse(JSON.stringify(getters.cardForm[item].formParams))
          : {}
      })
    } else {
      detailData = getters[page.type].formParams
        ? JSON.parse(JSON.stringify(getters[page.type].formParams))
        : {}
    }
  } else if (!page.checkType && page.checkFun) {
    // 不使用参数查询
    detailData = await dispatch(page.checkFun)
  } else if (page.checkType === 'checkByRow' && page.checkFun) {
    // 传入行数据多参数查询
    detailData = await dispatch(page.checkFun, params.row)
  } else if (page.checkType === 'checkByUid' && page.checkFun) {
    // 传入行数据uid参数查询
    const uidKey = page.checkKey || params.uidKey || 'uid'
    const fromRow = params.row ? params.row[uidKey] : ''
    const fromForm = params.form ? params.form[uidKey] : ''
    detailData = await dispatch(
      page.checkFun,
      page.checkUid ? page.checkUid : fromRow || fromForm
    )
  } else if (page.checkType === 'checkByKey' && page.checkFun) {
    // 传入行数据uid参数查询
    detailData = await dispatch(
      page.checkFun,
      params.row ? params.row[page.checkKey] : params.form[page.checkKey]
    )
  } else if (page.checkType === 'checkByQuery' && page.checkFun) {
    // 使用查询参数查询
    detailData = await dispatch(
      page.checkFun,
      page.query !== 'next' ? params.query : state.queryValues[page.name]
    )
  } else if (page.checkType === 'checkByForm' && page.checkFun) {
    // 使用表单数据查询
    detailData = await dispatch(page.checkFun, params.form)
  } else if (page.checkType === 'useRowData') {
    // 使用行数据更新详情页数据
    detailData = params.row
  } else if (page.checkType === 'useFormData') {
    // 使用当前表单数据更新详情页数据
    detailData = params.form
  }
  if (page.checkType === 'detailData') {
    // 使用设定详情页初始值修正查询数据
    detailData = detailData ? detailData : detailData instanceof Array ? [] : {}
    detailData = !detailData
      ? page.detailData
      : detailData && detailData instanceof Array
      ? detailData.concat(page.detailData)
      : Object.assign({}, detailData, page.detailData)
  }
  return detailData
}

const actions = {
  async loadList({ state, commit, dispatch }, payload) {
    const fun = typeof payload === 'string' ? payload : payload && payload.fun
    const data = payload && typeof payload === 'object' ? payload.data : undefined
    if (!fun) return null
    const seq = (state.listLoadingSeq || 0) + 1
    commit('baseSet', { key: 'listLoadingSeq', value: seq })
    commit('baseSet', { key: 'listLoading', value: true })
    const wait =
      (payload && typeof payload === 'object' && payload.timeout) ||
      axios.defaults.timeout ||
      30000
    const timer = setTimeout(() => {
      if (state.listLoadingSeq === seq) {
        commit('baseSet', { key: 'listLoading', value: false })
      }
    }, wait)
    try {
      if (typeof fun === 'function') return await fun()
      return await dispatch(fun, data)
    } catch (e) {
      return null
    } finally {
      clearTimeout(timer)
      if (state.listLoadingSeq === seq) {
        commit('baseSet', { key: 'listLoading', value: false })
      }
    }
  },
  async baseRequest({ state }, params = {}) {
    try {
      const { data: res } = await getRequest(
        params.method,
        state.baseURL + params.url,
        params.data,
        params.header,
        { timeout: params.timeout }
      )
      if (res.code !== 200 && !params.noErrorMsg) {
        Message({ message: res.msg, type: 'error' })
      } else if (res.code === 200 && params.msg) {
        Message({
          message: params.msg === true ? res.msg : params.msg,
          type: 'success'
        })
      }
      return res
    } catch (e) {
      const isTimeout =
        e && (e.code === 'ECONNABORTED' || /timeout/i.test((e && e.message) || ''))
      if (!params.noErrorMsg) {
        Message({
          message: isTimeout ? '请求超时，请稍后重试' : '请求失败，请稍后重试',
          type: 'error'
        })
      }
      return { code: 0, msg: isTimeout ? 'timeout' : 'request failed' }
    }
  },
  async dictionaryRequest({ state, commit }, params = {}) {
    if (!state.dictionarys[params.key] || params.sync) {
      const { data: res } = await getRequest(
        'GET',
        state.baseURL + params.url,
        params.data
      )
      if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
      var dictionary = []
      dictionary = resetAttribute(
        res.data,
        params.label,
        params.value,
        params.childrenKey
      )
      if (params.customValue) {
        dictionary.forEach((item) => {
          if (item.children && item.children.length) {
            item.children.forEach((child) => {
              child.value =
                item.label +
                (params.connector ? params.connector : '') +
                child.label
            })
          }
        })
      }
      if (params.customlabel) {
        dictionary.forEach((item) => {
          let itemValue = params.customKey ? item[params.customKey] : item.value
          item.label =
            params.customlabel === 'left'
              ? itemValue +
                (params.connector ? params.connector : '') +
                item.label
              : item.label +
                (params.connector ? params.connector : '') +
                itemValue
          if (item.children && item.children.length) {
            item.children.forEach((child) => {
              let childValue = params.customKey
                ? child[params.customKey]
                : child.value
              child.label =
                params.customlabel === 'left'
                  ? childValue +
                    (params.connector ? params.connector : '') +
                    child.label
                  : child.label +
                    (params.connector ? params.connector : '') +
                    childValue
            })
          }
        })
      }
      dictionary = dictionary
        ? dictionary.sort(sortBy(['code', 'num']))
        : dictionary
      commit('dictionarySet', { key: params.key, value: dictionary })
    }
  },
  async orgFieldsRequest({ state, commit }, params = {}) {
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + params.url,
      params.data
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    var orgField = []
    orgField = resetAttribute(
      res.data,
      params.label,
      params.value,
      params.childrenKey
    )
    // 组与组内均按编码数值稳定排序，避免编辑后行序跳动
    orgField = sortArray(orgField, ['code'], ['number'])
    commit('orgFieldsSet', { key: params.key, value: orgField })
  },
  // 请求第三方接口，处理跨域
  async httpsRequest({ state }, params = {}) {
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + '/organize/tool/http',
      params.data
    )
    if (res.code !== 200 && !params.noErrorMsg) {
      Message({ message: res.msg, type: 'error' })
    } else if (res.code === 200 && params.msg) {
      Message({
        message: params.msg === true ? res.msg : params.msg,
        type: 'success'
      })
    }
    return res
  },
  // 上传组件以formData格式上传文件
  async uploadFile({ state }, params = {}) {
    /* params.url根据类型上传的不同文件，传入对应的url */
    const { data: res } = await axios({
      method: 'POST',
      url: state.baseURL + params.url,
      data: params.data
    })
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res
  },
  // js以Json格式上传Base64图片
  async uploadImgBase64({ state }, params) {
    const { data: res } = await getRequest(
      'POST',
      state.baseURL + '/static/files/imageBase64',
      params
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res
  },
  // js以Json格式上传Base64签名
  async uploadSignatureBase64({ state }, params) {
    const { data: res } = await getRequest(
      'POST',
      state.baseURL + '/static/files/signatureBase64',
      params
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res
  },
  // 中行北斗获取车辆列表
  async getZhbdCarList({ state, dispatch }) {
    const res = await dispatch('httpsRequest', {
      data: {
        url:
          state.zhbdURL +
          '/gps-web/api/get_car_list_recur.jsp?sessionId=swTfB2X79GKyN3X09VYzEmMkdzZxZGbvBVYBFmV382NJdjQoc2bfV2XoRGK0JlJMRmSgVWcLNXcolmJ5Uzb1EXNY',
        type: 'get',
        param: ''
      }
    })
    var carList = res.data && res.data.list ? res.data.list : []
    return carList
  },
  // 中行北斗获取批量车辆定位信息
  async getZhbdPositionById({ state, dispatch }, carIds) {
    const res = await dispatch('httpsRequest', {
      data: {
        url:
          state.zhbdURL +
          '/gps-web/api/get_gps_r.jsp?carIds=' +
          carIds +
          '&simple=false&sessionId=swTfB2X79GKyN3X09VYzEmMkdzZxZGbvBVYBFmV382NJdjQoc2bfV2XoRGK0JlJMRmSgVWcLNXcolmJ5Uzb1EXNY',
        type: 'get',
        param: ''
      }
    })
    var positions = res.data && res.data.list ? res.data.list : []
    return positions
  },
  // 中行北斗获取车辆定位信息
  async getZhbdPosition({ state, dispatch }, carPlate) {
    const res = await dispatch('httpsRequest', {
      data: {
        url:
          state.zhbdURL +
          '/gps-web/api/get_gps_r_plate.jsp?carPlate=' +
          carPlate +
          '&simple=false&sessionId=swTfB2X79GKyN3X09VYzEmMkdzZxZGbvBVYBFmV382NJdjQoc2bfV2XoRGK0JlJMRmSgVWcLNXcolmJ5Uzb1EXNY',
        type: 'get',
        param: ''
      }
    })
    var positions = res.data && res.data.list ? res.data.list : []
    return positions
  },
  // 中行北斗获取车辆历史定位信息
  async getZhbdPositions({ state, dispatch }, params) {
    const res = await dispatch('httpsRequest', {
      data: {
        url:
          state.zhbdURL +
          '/gps-web/api/get_gps_h_plate.jsp?carPlate=' +
          params.carPlate +
          '&startTime=' +
          params.startTime +
          '&endTime=' +
          params.endTime +
          '&filter0=' +
          params.filter0 +
          '&maxSpeed=' +
          params.maxSpeed +
          '&filterInvalid=' +
          params.filterInvalid +
          '&queryAlarm=' +
          params.queryAlarm +
          '&stopLong=' +
          params.stopLong +
          '&plateColor=' +
          params.plateColor +
          '&simple=false&sessionId=swTfB2X79GKyN3X09VYzEmMkdzZxZGbvBVYBFmV382NJdjQoc2bfV2XoRGK0JlJMRmSgVWcLNXcolmJ5Uzb1EXNY',
        type: 'get',
        param: ''
      }
    })
    var positions = res.data ? res.data : []
    return positions
  },
  // 中行北斗关闭实时视频播放
  async closeZhbdVideo({ state, dispatch }, uid) {
    const res = await dispatch('httpsRequest', {
      data: {
        url: state.zhbdURL + '/httpflv.rctr.close.' + uid,
        type: 'get',
        param: ''
      }
    })
    return res
  },
  // 中行北斗获取车辆历史监控视频
  async getZhbdVideos({ state, dispatch }, url) {
    const res = await dispatch('httpsRequest', {
      data: {
        url: state.zhbdURL + url,
        type: 'get',
        param: ''
      }
    })
    var videoFiles = res.data && res.data.result ? res.data.result : []
    return videoFiles
  },
  // 七牛云存储服务
  async getQiniuToken({ state }, data) {
    const { data: res } = await getRequest(
      'POST',
      state.baseURL + '/organize/qiniu/getuploadtoken',
      data
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res.data ? res.data.token : ''
  },
  async postQiniuFile({ state }, data) {
    const { data: res } = await getRequest(
      'POST',
      state.baseURL + '/organize/qiniu/videomsg',
      data
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res
  },
  async getQiniuFile({ state }, uid) {
    const videoUid = normalizeQiniuUid(uid)
    if (!videoUid) return ''
    // 跟当前页面同域走 Caddy /organize*，不要打 zfapi：浏览器播 HLS 会跨域且容易 RST
    const origin =
      typeof window !== 'undefined' && window.location && window.location.origin
        ? window.location.origin
        : state.baseURL
    return (
      origin +
      '/organize/qiniu/hls.m3u8?uid=' +
      encodeURIComponent(videoUid)
    )
  },
  async deleteQiniuFile({ state }, data) {
    const payload =
      typeof data === 'string'
        ? { uid: data }
        : data && typeof data === 'object'
        ? data
        : {}
    if (!payload.uid && !payload.key) return
    try {
      await getRequest(
        'DELETE',
        state.baseURL + '/organize/qiniu/delete',
        payload
      )
    } catch (err) {
      console.warn('删除七牛云视频失败', err)
    }
  },
  async deleteUploadedImage({ state }, uid) {
    const id = String(uid || '').trim()
    if (!id) return
    try {
      await getRequest(
        'DELETE',
        state.baseURL + state.uploadImage + '/' + encodeURIComponent(id)
      )
    } catch (err) {
      console.warn('删除图片失败', err)
    }
  },
  async rollbackUnsavedUploadSession({ state, commit, dispatch }) {
    const session = state.unsavedUploadSession || {}
    if (session.committed) return 0
    let count = 0
    const images = Array.isArray(session.images) ? session.images : []
    for (let i = 0; i < images.length; i++) {
      const item = images[i]
      if (!item || !item.uid) continue
      await dispatch('deleteUploadedImage', item.uid)
      count += 1
    }
    const videos = Array.isArray(session.qiniu) ? session.qiniu : []
    for (let i = 0; i < videos.length; i++) {
      const item = videos[i]
      if (!item) continue
      await dispatch('deleteQiniuFile', {
        uid: item.uid,
        key: item.key,
        bucket: item.bucket
      })
      count += 1
    }
    commit('unsavedUploadSessionSet', {
      images: [],
      qiniu: [],
      committed: true
    })
    return count
  },
  async deleteQiniuFiles({ dispatch }, uids) {
    const list = Array.isArray(uids) ? uids : uids ? [uids] : []
    for (let i = 0; i < list.length; i++) {
      if (list[i]) {
        await dispatch('deleteQiniuFile', list[i])
      }
    }
  },
  // 获取短信验证码
  async sendSms({ state }, params) {
    const telphoneNum = String((params && (params.telphoneNum || params.phone)) || '')
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + '/act/sms/register',
      { telphoneNum }
    )
    const code = res && res.code
    const msg = (res && (res.msg || res.message)) || '发送验证码失败'
    if (code !== 200) {
      Message({ message: msg, type: 'error' })
      return false
    }
    Message({ message: '获取验证码成功', type: 'success' })
    return true
  },
  // 发送提醒短信
  async sendNotice({ state }, params) {
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + '/act/sms/sendmsg',
      params
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    Message({ message: '已发送车辆上线提醒', type: 'success' })
  },
  // 获取报表图片url（base64）
  async getReportBase64Pic({ state }, params) {
    const query = Object.assign({}, params)
    if (!query.orgUid && state.user && state.user.orgValue) {
      query.orgUid = state.user.orgValue
    }
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + '/rule/report/native/showBase64',
      query
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    return res && res.data ? 'data:image/jpg;base64,' + res.data : ''
  },
  // 获取文件
  async getFile({ state }, params) {
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + state.uploadfile + '/' + params.uid
    )
    if (res.code) return Message({ message: res.msg, type: 'error' })
    return res
  },
  // 生成签名
  async generateSignature({ state }, names) {
    const { data: res } = await getRequest(
      'GET',
      state.baseURL + '/tools/image/cover',
      { name: names }
    )
    if (res.code !== 200) return Message({ message: res.msg, type: 'error' })
    Message({ message: '签名生成成功', type: 'success' })
    return res
  },

  async handleCliks({ state, getters, commit, dispatch }, params) {
    if (
      isBlockedBidLevelAction(getters['user/orgType'], state.currentStep.theme, {
        name: params.buttonName,
        buttonName: params.buttonName,
        code: params.code
      }, state)
    ) {
      Message({ message: '当前机构仅可查看，不能进行该操作', type: 'warning' })
      params.blocked = true
      return params
    }
    /**************** 点击特殊按钮固定事件 ************************/
    // 预览行数据或表单中图片
    if (params.code === 'preview') {
      const page =
        params.detailPage && Array.isArray(params.detailPage)
          ? null
          : params.detailPage
      previewFile(state, commit, dispatch, params, page)
      return params
    }
    // 刷新页面数据
    if (params.code === 'refresh') {
      dispatch(
        params.data.refreshFun
          ? params.data.refreshFun
          : params.data.getListFun
          ? params.data.getListFun
          : params.data.getDetailFun
      )
      return params
    }
    // 删除列表数据
    if (params.code === 'delete') {
      let deleteTip = '此操作将永久删除该条数据, 是否继续?'
      if (typeof params.data.deleteConfirm === 'function') {
        deleteTip = params.data.deleteConfirm({
          ...params,
          userName: state.user.userName
        })
      } else if (params.data.deleteConfirm) {
        deleteTip = params.data.deleteConfirm
      }
      let confirmResult = await MessageBox.confirm(
        deleteTip,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') {
        Message({ message: '已经取消了删除', type: 'info' })
        return params
      }
      const videoUids = collectRowVideoUids(params.row)
      if (params.data.upload) {
        deleteRow(params.filesData, params.row[params.uidKey], params.uidKey)
        commit('baseSet', {
          key: 'filesData',
          value: params.filesData
        })
      } else {
        if (params.data.deleteFun && params.row[params.uidKey]) {
          const deleteFun =
            typeof params.data.deleteFun === 'function'
              ? params.data.deleteFun(params.row)
              : params.data.deleteFun
          let res = await dispatch(deleteFun, params.row[params.uidKey])
          if (res.code !== 200) return params
        }
        deleteRow(
          params.data.rowData ? params.data.rowData : params.data.collapsesData,
          params.row[params.uidKey],
          params.uidKey
        )
      }
      if (videoUids.length) {
        await dispatch('deleteQiniuFiles', videoUids)
      }
      if (params.data.getListFun) {
        if (params.data.rowTotal % this.limit === 1 && this.page !== 1) {
          commit('pageSet', {
            key: params.name,
            value: 1
          })
          dispatch('loadList', { fun: params.data.getListFun })
        } else {
          dispatch('loadList', { fun: params.data.getListFun })
        }
      }
      if (params.data.getParentFun) {
        dispatch(params.data.getParentFun)
      }
      return params
    }
    // 确认数据
    if (params.code === 'confirm') {
      /* if (state.pageStatus[params.name] === 'add') {
        let res = await this.$store.dispatch(params.data.saveFun)
        if (res.code !== 200) return params
      } */
      let confirmResult = await MessageBox.confirm(
        '请确定是要确认或上报当前选择数据?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') {
        Message({ message: '已经取消了确认', type: 'info' })
        return params
      }
      if (params.data.confirmFun) {
        let data = params.row ? params.row : state.queryValues[params.name]
        data.uid = state.currentUids[params.name]
          ? state.currentUids[params.name]
          : params.row
          ? params.row[params.uidKey]
          : ''
        data.state =
          params.buttonName === '退回' || params.buttonName === '拒绝'
            ? '审批拒绝'
            : '审批通过'
        let res = await dispatch(params.data.confirmFun, data)
        if (res.code !== 200) return params
        commit('pageStatusSet', {
          key: params.name,
          value: 'check'
        })
        if (params.data.getListFun || params.data.getDetailFun) {
          if (params.data.getListFun) {
            dispatch('loadList', { fun: params.data.getListFun })
          } else {
            dispatch(params.data.getDetailFun)
          }
        }
      }
      return params
    }
    // 获取并展示二维码（行内或顶部按钮均可，顶部按钮无 row）
    if (params.code === 'qrcode') {
      let qcodeInfo = params.row && params.row.qcodeInfo
      // 披露二维码：与进场码分离
      if (
        params.buttonName === '披露二维码' &&
        params.row &&
        (params.row.discloseQcodeInfo ||
          (params.row.qcodeInfo && params.row.qcodeInfo.discloseQcodeInfo))
      ) {
        qcodeInfo =
          params.row.discloseQcodeInfo ||
          params.row.qcodeInfo.discloseQcodeInfo
      }
      // 运输单二维码（原「签收二维码」）
      if (
        (params.buttonName === '二维码' ||
          params.buttonName === '签收二维码') &&
        params.row &&
        params.row.signQcodeInfo
      ) {
        qcodeInfo = params.row.signQcodeInfo
      }
      if (!qcodeInfo || !qcodeInfo.qcodeUrl) {
        const qcodeArg =
          params.row && params.uidKey ? params.row[params.uidKey] : undefined
        const qcodeFun =
          params.data &&
          (params.data.getQcode
            ? params.data.getQcode
            : params.data.getDetailFun)
        const detailData = qcodeFun ? await dispatch(qcodeFun, qcodeArg) : null
        qcodeInfo =
          params.data && params.data.getQcode
            ? detailData
            : detailData && detailData.qcodeInfo
        if (
          params.buttonName === '披露二维码' &&
          detailData &&
          (detailData.discloseQcodeInfo ||
            (detailData.qcodeInfo && detailData.qcodeInfo.discloseQcodeInfo))
        ) {
          qcodeInfo =
            detailData.discloseQcodeInfo ||
            detailData.qcodeInfo.discloseQcodeInfo
        }
        if (
          (params.buttonName === '二维码' ||
            params.buttonName === '签收二维码') &&
          detailData &&
          detailData.signQcodeInfo
        ) {
          qcodeInfo = detailData.signQcodeInfo
        }
      }
      if (!qcodeInfo || !qcodeInfo.qcodeUrl) {
        Message({ message: '未获取到二维码', type: 'warning' })
        return params
      }
      commit('baseSet', { key: 'qcodeInfo', value: qcodeInfo })
      commit('baseSet', {
        key: 'qrcodeFormVisible',
        value: true
      })
      return params
    }
    // 用户密码初始化
    if (params.code === 'resetPassWord') {
      let confirmResult = await MessageBox.confirm(
        '此操作将初始化用户密码为默认值, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') {
        Message({ message: '已经取消了密码初始化', type: 'info' })
        return params
      }
      dispatch('user/resetPassWord', params.row)
      return params
    }
    // 数据推送
    if (params.code === 'pushing') {
      let confirmResult = await MessageBox.confirm(
        '请确定是要推送当前选择数据?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') {
        Message({ message: '已经取消了推送', type: 'info' })
        return params
      }
      let res = await dispatch(
        params.data.pushingFun,
        params.row[params.uidKey]
      )
      if (res.code !== 200) return params
      dispatch('loadList', { fun: params.data.getListFun })
      return params
    }
    // 返回上一页面
    if (params.code === 'return') {
      goBack(commit, dispatch, params.data)
      return params
    }
    // 通过路由跳转至对应页面
    if (params.code === 'path') {
      gotoPath(commit, params.path, state)
      return params
    }
    // 保存或提交页面数据
    if (params.code === 'save') {
      if (params.data.saveFun) {
        let res = await dispatch(params.data.saveFun)
        if (res.code !== 200) return params
        if (state.pageStatus[params.name] === 'add') {
          commit('pageStatusSet', {
            key: params.name,
            value: 'edit'
          })
        }
      }
    }

    /*************** 点击页面自定义按钮事件 ************************/

    if (!params.detailPage) return params
    const page = Array.isArray(params.detailPage)
      ? (() => {
          const hit = params.detailPage.find((item) => {
            const element = getObjAttribute(Object.assign({}, item), params)
            return (
              (params.code && element.code === params.code) ||
              (params.buttonName && element.buttonName === params.buttonName) ||
              (element.codes && element.codes.includes(params.code)) ||
              (element.buttonNames &&
                element.buttonNames.includes(params.buttonName))
            )
          })
          return hit ? getObjAttribute(Object.assign({}, hit), params) : hit
        })()
      : getObjAttribute(Object.assign({}, params.detailPage), params)
    if (!page || !page.type) return params
    // 返回上一页面
    if (page.type === 'goBack') {
      goBack(commit, dispatch, params.data)
      return params
    }
    // 通过路由跳转至对应页面
    if (page.type === 'path') {
      gotoPath(commit, page.path, state)
      return params
    }
    // 刷新当前页面
    if (page.type === 'refresh') {
      dispatch(
        params.data.refreshFun
          ? params.data.refreshFun
          : params.data.getListFun
          ? params.data.getListFun
          : params.data.getDetailFun
      )
      return params
    }
    // 预览文件
    if (page.type === 'preview') {
      await previewFile(state, commit, dispatch, params, page)
      return params
    }
    // 展开列表当前行或所有折叠行
    if (page.type === 'expand') {
      const expandRowKeys = !page.expandAll
        ? [params.row[params.uidKey]]
        : getSameKeyHalfValues(
            params.data.rowData,
            page.uidKey ? page.uidKey : 'uid'
          )
      commit('expandRowKeysSet', {
        key: page.name,
        value: expandRowKeys
      })
      return params
    }
    // 更新参数对象中新页面name
    params.name = page.name
    // 组件打开或新页面跳转
    if (page.type === 'dialogForm') {
      // 打开弹窗表单
      commit('baseSet', {
        key: 'dialogName',
        value: page.name
      })
      commit('baseSet', {
        key: 'dialogFormVisible',
        value: true
      })
    } else if (page.type === 'dialogTable') {
      // 打开弹窗列表
      commit('baseSet', {
        key: 'dialogName',
        value: page.name
      })
      commit('baseSet', {
        key: 'dialogTableVisible',
        value: true
      })
    } else if (page.type === 'drawerTable') {
      // 打开抽屉列表
      commit('baseSet', {
        key: 'drawerName',
        value: page.name
      })
      commit('baseSet', {
        key: 'drawerTableVisible',
        value: true
      })
      if (getters[page.type].queryParams) {
        const queryValues = JSON.parse(
          JSON.stringify(getters[page.type].queryParams)
        )
        commit('queryValuesSet', {
          key: page.name,
          value: queryValues
        })
      }
    } else {
      commit('baseSet', { key: 'loading', value: true })
      // 试卷库/公共试卷库进入「试卷试题列表」时，同步 paper 行，供试题页按钮权限判断
      if (page.name === 'paperQuestion' && params.row) {
        commit('currentRowSet', {
          key: 'paper',
          value: params.row
        })
      }
      // 跳转新页面
      commit('stepSet', {
        type: 'forward',
        forward: page
      })
    }
    try {
      // 设置新页面状态
      commit('pageStatusSet', {
        key: page.name,
        value: page.pageStatus
          ? page.pageStatus
          : params.code
          ? params.code
          : 'form'
      })
      // 设置新页面父级页面uid
      commit('parentUidsSet', {
        key: page.name,
        value: params.formUid
          ? params.formUid
          : params.form
          ? params.form[page.uidKey]
          : ''
      })
      // 设置新页面uid
      commit('currentUidsSet', {
        key: page.name,
        value: page.checkUid
          ? page.checkUid
          : params.row
          ? params.row[page.checkKey ? page.checkKey : params.uidKey]
          : params.form
          ? params.form[page.checkKey ? page.checkKey : params.uidKey]
          : params.checkValue
          ? params.checkValue
          : ''
      })
      // cardForm表单页面状态及uid设置
      if (page.type === 'cardForm') {
        getters[page.type].subcomponents.forEach((item) => {
          commit('pageStatusSet', {
            key: item,
            value: page.pageStatus
              ? page.pageStatus
              : params.code
              ? params.code
              : 'form'
          })
          commit('parentUidsSet', {
            key: item,
            value: params.formUid
              ? params.formUid
              : state.currentUids[params.name]
          })
          commit('currentUidsSet', {
            key: item,
            value: page.checkUid
              ? page.checkUid
              : params.row
              ? params.row[params.uidKey]
              : params.form
              ? params.form[page.uidKey]
              : params.checkValue
              ? params.checkValue
              : ''
          })
        })
      }
      // 获取新组件或页面数据
      let detailData = null
      try {
        detailData = await getDetailData(state, getters, dispatch, params, page)
      } catch (e) {
        detailData = null
      }
      if (!detailData && params.row) {
        detailData = Object.assign({}, params.row)
      }
      commit(page.commitFun ? page.commitFun : 'formValuesSet', {
        key: page.name,
        value: detailData ? detailData : null
      })
      if (page.type === 'cardForm') {
        getters.cardForm.cardFormNames.forEach((card) => {
          commit('formValuesSet', {
            key: card,
            value: detailData[card]
          })
        })
      }
      // 新页面列表展开状态
      const expandRowKeys =
        page.expandAll &&
        !page.expandColumn &&
        getters[page.type] &&
        getters[page.type].rowData
          ? getSameKeyHalfValues(
              getters[page.type].rowData,
              page.uidKey ? page.uidKey : 'uid'
            )
          : []
      commit('expandRowKeysSet', {
        key: page.name,
        value: expandRowKeys
      })
    } finally {
      commit('baseSet', { key: 'loading', value: false })
    }
    return params
  }
}

export default actions
